import { TEMP_OPTIONS, CURRENCY_OPTIONS, CURRENCY_NULL, CAPACITY_UNITS, ENERGY_OPTIONS } from "@/utils/options"
import { initTempStore, saveCurrentProject, fetchProjectDetails } from "./actions"
export default {
  namespaced: true,
  state: () => ({
    currentProject: null,
    digitalECAT: null,
    // auditMode: null,
    heatingECAT: [],
    pre: {
      plantCfg: {},
      weatherProfile: {},
      equipmentCfg: {},
      observation: {},
      equipmentList: {},
      profiles: [],
      profileCfg: {},
      chillerCfg: {},

      baselineCfg: {},
      baselineList: [],
      heatingPreview: {}
    },
    post: {
      clConfig: {},
      weatherProfile: {},
      clusters: { list: [] },
      equipmentList: { chiller: [], CWP: [], CHWP: [], CT: [], other: [] },
      profileEqpt: { type: 1, profileList: [], chillerList: [] },
      optionList: [],

      heatConfig: {},
      heatEquips: { heatPump: [] },
      heatClusters: [],
      heatSolutions: [],
      heatOptimize: [],
      solutions: []
    }
  }),
  getters: {
    digitalECAT: state => state.digitalECAT,
    heatingECAT: state => state.heatingECAT || [],
    currentProject: state => state.currentProject,
    projectCfg: state => state.currentProject.projectCfg || {},

    weatherProfile: state => state.currentProject.pre.weatherProfile || {},
    tempUnit: state => TEMP_OPTIONS.find(x => x.value == state.currentProject.pre.plantCfg.tempUnit) || TEMP_OPTIONS[0],
    currency: state => CURRENCY_OPTIONS.find(x => x.value == state.currentProject.pre.plantCfg.currency) || CURRENCY_NULL,
    capacityUnit: state =>
      [3, 4].includes(state.currentProject?.projectObjective?.objective)
        ? CAPACITY_UNITS[2]
        : CAPACITY_UNITS.find(x => x.value == state.currentProject.pre.equipmentCfg.chillerCfg?.capacityUnit) || CAPACITY_UNITS[0],

    plantCfg: state => state.currentProject.pre.plantCfg || {},
    equipmentCfg: state => state.currentProject.pre.equipmentCfg || { a: 1 },
    chillerCfg: state => state.currentProject.pre.equipmentCfg?.chillerCfg || {},
    chillerCfgType: state => state.currentProject.pre.equipmentCfg?.chillerCfg?.type || 0,
    pumpCfg: state => state.currentProject.pre.equipmentCfg?.pumpCfg || {},

    observation: state => state.currentProject.pre.observation || {},

    profiles: state => state.currentProject.pre.profiles || [],
    profileCfg: state => state.currentProject.pre.profileCfg || {},
    baseMonth: state => {
      const { estimatePath, calculateMethod, baseMonth } = state.currentProject.pre.profileCfg
      return estimatePath * calculateMethod === 1 ? baseMonth : 0
    },

    equipmentList: state => state.currentProject.pre.equipmentList || {},
    chillerList: state => state.currentProject.pre.equipmentList?.chiller || [],
    boilerList: state => state.currentProject.pre.equipmentList?.boiler || [],

    preEfficiency: state => state.currentProject.pre?.totalEfficiency || {},
    preEnergyCost: state => state.currentProject.pre?.totalElectricityCost || {},

    objective: state => state.currentProject.projectObjective?.objective ?? 0,
    proposeEqptIDs: state => state.currentProject.projectObjective?.proposedEquipmentIdList ?? [],

    post: state => state.currentProject?.post || {},
    postWeatherProfile: state => state.currentProject?.post?.weatherProfile || {},
    clConfig: state => state.currentProject.post?.clConfig || {},
    clusters: state => state.currentProject.post?.clusters || {},
    postEqptList: state => state.currentProject.post?.equipmentList || [],
    postEqptChillers: state => state.currentProject.post?.equipmentList?.chiller || [],
    profileEqpt: state => state.currentProject.post?.profileEqpt || {},
    optionList: state => state.currentProject.post?.optionList || [],
    proposeCfg: state => state.currentProject.post?.proposeCfg || [],

    boilerCfg: state => state.currentProject.pre?.equipmentCfg?.boilerCfg || {},
    energyType: state => ENERGY_OPTIONS.find(x => x.value === state.currentProject.pre?.equipmentCfg?.boilerCfg?.energyType) || ENERGY_OPTIONS.slice(0, -1),
    baselineCfg: state => state.currentProject.pre?.baselineCfg || {},
    baselineList: state => state.currentProject.pre?.baselineList || [],
    heatingPreview: state => state.currentProject.pre?.heatingPreview || {},

    heatConfig: state => state.currentProject.post?.heatConfig || {},
    auditMode: state => state.currentProject?.auditMode,
    heatEquips: state => state.currentProject.post?.heatEquips || {},
    heatClusters: state => state.currentProject.post?.heatClusters || [],
    heatSolutions: state => state.currentProject.post?.heatSolutions || [],
    heatOptimize: state => state.currentProject.post?.heatOptimize || [],
    solutions: state => state.currentProject.post?.solutions || []
  },
  mutations: {
    STORE_DIGITAL_E_CAT(state, datas) {
      state.digitalECAT = [...datas]
    },
    STORE_HEATING_MODEL(state, datas) {
      state.heatingECAT = [...datas]
    },
    STORE_CURRENT_PROJECT(state, data) {
      const pre = { ...state.pre, ...state.currentProject?.pre, ...data?.pre }
      const post = { ...state.post, ...state.currentProject?.post, ...data?.post }
      state.currentProject = { ...state.currentProject, ...data, pre, post }
    },

    STORE_REVIEW_CHANGES(state, { initChanges = false, initSnapShot = false, ...reviewChanges }) {
      state.currentProject = {
        ...state.currentProject,
        reviewChanges: structuredClone(reviewChanges),
        ...(initChanges ? { initChanges: structuredClone(reviewChanges) } : {}),
        ...(initSnapShot ? { initSnapShot: structuredClone(reviewChanges) } : {})
      }
    },
    STORE_INIT_CHANGES(state, initChanges) {
      const version = (state.currentProject?.initChanges?.version || 0) + 1
      state.currentProject = {
        ...state.currentProject,
        initChanges: { ...structuredClone(initChanges), version }
      }
    },

    INIT_PROJECT_STORE(state) {
      state.currentProject = { pre: structuredClone(state.pre), post: structuredClone(state.post) }
    },

    STORE_PROJ_PRE(state, { path, value }) {
      const paths = path.split(".")
      const lastKey = paths.pop()
      const target = paths.reduce((obj, key) => obj[key], state.currentProject.pre)
      target[lastKey] = typeof value === "object" ? { ...target[lastKey], ...value } : value
    },

    STORE_PROJ_PRE(state, payload) {
      state.currentProject.pre = state.currentProject.pre || {}
      for (const [path, value] of Object.entries(payload)) {
        const paths = path.split(".")
        const lastKey = paths.pop()

        let target = paths.reduce((obj, key) => {
          if (!obj[key]) obj[key] = {}
          return obj[key]
        }, state.currentProject.pre)

        if (typeof value === "object" && !Array.isArray(value)) {
          target[lastKey] = { ...target[lastKey], ...value }
        } else {
          target[lastKey] = value
        }
      }
    },

    STORE_OBSERVATIONS(state, data) {
      state.currentProject.pre.observation = { ...data }
    },
    STORE_OBSERVATION(state, data) {
      state.currentProject.pre.observation[data.type] = { ...data }
    },

    STORE_PROJ_POST(state, payload) {
      state.currentProject.post = state.currentProject.post || {}
      for (const [path, value] of Object.entries(payload)) {
        const paths = path.split(".")
        const lastKey = paths.pop()

        const target = paths.reduce((obj, key) => {
          if (!obj[key]) obj[key] = {}
          return obj[key]
        }, state.currentProject.post)

        if (typeof value === "object" && !Array.isArray(value)) {
          target[lastKey] = { ...target[lastKey], ...value }
        } else {
          target[lastKey] = value
        }
      }
    }
  },
  actions: {
    initTempStore,
    saveCurrentProject,
    fetchProjectDetails,
    storeDigitalECAT({ commit }, datas) {
      commit("STORE_DIGITAL_E_CAT", datas)
    },
    storeHeatingModel({ commit }, datas) {
      commit("STORE_HEATING_MODEL", datas)
    },
    storeProject({ commit }, data) {
      commit("STORE_CURRENT_PROJECT", data)
    },
    storeInitChanges({ commit }, initChanges) {
      commit("STORE_INIT_CHANGES", initChanges)
    },

    clearProjectStore({ commit }) {
      commit("INIT_PROJECT_STORE")
    },

    storeProjectPre({ commit }, { path, value }) {
      commit("STORE_PROJ_PRE", { path, value })
    },

    storeProjectPre({ commit }, payload) {
      commit("STORE_PROJ_PRE", payload)
    },

    storeObservations({ commit }, [data, type]) {
      if (!type) commit("STORE_OBSERVATIONS", data)
      else commit("STORE_OBSERVATION", data)
    },

    storeProjectPost({ commit }, payload) {
      commit("STORE_PROJ_POST", payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/projectPre/index.js